import { AHText, TouchableBox } from "arkh";
import { FormattedMessage } from "react-intl";
import { useNavigation } from "@react-navigation/native";

export function LoginWithIndividualAccountFooter() {
  const navigation = useNavigation();
  return (
    <>
      <AHText
        type="detail"
        color="text-secondary"
        textAlign="center"
        spaceVertical="medium"
      >
        <FormattedMessage
          defaultMessage="Do you want to log in with your personal account instead?"
          description="GroupDeviceOTP log in with personal account text"
        />
      </AHText>
      <TouchableBox
        onPress={() => {
          navigation.goBack();
        }}
      >
        <AHText
          type="detail"
          style={{
            textDecorationLine: "underline",
          }}
          color="text-primary"
          textAlign="center"
        >
          <FormattedMessage
            defaultMessage="Log in with email and password"
            description="GroupDeviceOTP log in with personal cta"
          />
        </AHText>
      </TouchableBox>
    </>
  );
}
